import React from 'react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import Button from "components/CustomButtons/Button.jsx";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import Success from '../Typography/Success';
import Loading from '../Loading/Loading';

function Transition(props) {
    return <Slide direction="down" {...props} />;
  }

class LoadingModal extends React.Component {
    render() {

        const { classes }  = this.props;

        return (
            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal + " " + classes.modalSmall
                }}
                open={this.props.open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="small-modal-slide-title"
                aria-describedby="small-modal-slide-description"
            >
                <DialogContent
                    id="small-modal-slide-description"
                    className={
                        classes.modalBody + " " + classes.modalSmallBody
                    }
                    style={{ paddingTop: 80, paddingBottom: 80 }}
                >
                    <Loading />
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(notificationsStyle)(LoadingModal);